import { atom, createStore } from 'jotai'

export const myStore = createStore()
